[
  {
    "id": "minimum_spend",
    "label": "Minimum spend",
    "tooltip": "Spend on food and drinks",
    "description": "To hire the space, your group of guests just has to spend a pre-agreed minimum amount on food or drinks during the event."
  },
  {
    "id": "hire_fee",
    "label": "Hire fee",
    "tooltip": "Pay a flat fee",
    "description": "Set fee for hiring the space. Catering and decorations are not included but sometimes can be ordered at the venue or on a BYO basis."
  },
  {
    "id": "per_person",
    "label": "Per person",
    "labelLong": "Package per person",
    "tooltip": "Fixed package per person",
    "description": "Package per person deals include food, drinks or other options. Get in touch with the venue manager if you’d like to know more about what’s being offered."
  }
]
